// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let AgentInfo = require("../../common/Components/AgentInfo.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("../../common/Components/FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let DevelopmentUnitSearchResultAgent_newDevelopmentSampleUnit_graphql = require("../../../__generated__/DevelopmentUnitSearchResultAgent_newDevelopmentSampleUnit_graphql.bs.js");

let convertFragment = DevelopmentUnitSearchResultAgent_newDevelopmentSampleUnit_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, DevelopmentUnitSearchResultAgent_newDevelopmentSampleUnit_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(DevelopmentUnitSearchResultAgent_newDevelopmentSampleUnit_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, DevelopmentUnitSearchResultAgent_newDevelopmentSampleUnit_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(DevelopmentUnitSearchResultAgent_newDevelopmentSampleUnit_graphql.node, convertFragment, fRef);
}

let UnitFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function DevelopmentUnitSearchResultAgent$WithoutErrorBoundary(props) {
  let __size = props.size;
  let size = __size !== undefined ? __size : "small";
  let match = RescriptRelay_Fragment.useFragment(DevelopmentUnitSearchResultAgent_newDevelopmentSampleUnit_graphql.node, convertFragment, props.unit);
  let agent = match.agent;
  if (agent !== undefined) {
    return JsxRuntime.jsx(AgentInfo.make, {
      agent: agent.fragmentRefs,
      size: size
    });
  } else {
    return null;
  }
}

let WithoutErrorBoundary = {
  make: DevelopmentUnitSearchResultAgent$WithoutErrorBoundary
};

function DevelopmentUnitSearchResultAgent(props) {
  let __size = props.size;
  let size = __size !== undefined ? __size : "small";
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "development unit agent",
    children: JsxRuntime.jsx(DevelopmentUnitSearchResultAgent$WithoutErrorBoundary, {
      unit: props.unit,
      size: size
    })
  });
}

let make = DevelopmentUnitSearchResultAgent;

exports.UnitFragment = UnitFragment;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* AgentInfo Not a pure module */
